module.exports = __webpack_public_path__ + "img/double_arrow.0d9f32de.svg";